import { useFetch } from 'hooks/useFetch';
import React, { use, useEffect, useState } from 'react'
import { NotificationManager } from 'react-notifications';
import { Button, Card, CardHeader, Col, FormGroup, Input, Label, Row } from 'reactstrap';

const RRPPriceDetails = () => {
  const [formData, setFormData] = useState({
    weekend_price: 0,
    weekday_price: 0,
    wednesday_price: 0,
  })
  const { data, isPending, error } = useFetch(process.env.REACT_APP_NODE_SERVER_URL + "/api/getRRPPriceDetails");

  useEffect(() => {
    if (data) {
      setFormData({
        rrp_price_id: data.rrp_price_id,
        weekend_price: data.weekend_price || 0,
        weekday_price: data.weekday_price || 0,
        wednesday_price: data.wednesday_price || 0,
      });
    }
  }, [data]);

  const handleSubmit = async () => {
    try {
      const response = await fetch(process.env.REACT_APP_NODE_SERVER_URL + "/api/updateRRPPriceDetails", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        const result = await response.json();
         NotificationManager.error(result.error,'', 3000);
        return;
      }

      const result = await response.json();
      console.log("RRP price details updated successfully:", result);
    } catch (error) {
      console.log(error?.data)
      console.error("Error updating RRP price details:", error?.msg);
      // Optionally, you can show a notification or alert to the user
      // alert("Failed to update RRP price details. Please try again.");
    }
  }

  useEffect(() => {
    if (error) {
      console.error("Error fetching RRP price details:", error);
      // Optionally, you can show a notification or alert to the user
      // alert("Failed to fetch RRP price details. Please try again.");
      NotificationManager.error(error, '', 3000);
    }
  }, [error]);

  return (
    <div className='container pt-9'>
      <Card>
        <CardHeader className="border-0">
          <h3 className="mb-0">RRP Price Details</h3> 
          {isPending && <div>Loading...</div>}
          <Row className='mt-3'>
            <Col md={12} sm={12} className='d-flex justify-content-center align-items-center gap-5 mt-5'>
              <Label className='text-nowrap'>Weekdays Price</Label>
              <Input type="number" style={{width:"150px"}}  value={formData.weekday_price} onChange={(e) => setFormData({ ...formData, weekday_price: e.target.value })} />
            </Col>
            <Col md={12} sm={12} className='d-flex justify-content-center align-items-center gap-5 mt-5'>
              <Label className='text-nowrap'>Wednesday Price</Label>
              <Input type="number" style={{width:"150px"}} value={formData.wednesday_price} onChange={(e) => setFormData({ ...formData, wednesday_price: e.target.value })} />
            </Col>
            <Col md={12} sm={12} className='d-flex justify-content-center align-items-center gap-5 mt-5'>
              <Label className='text-nowrap'>Weekends Price</Label>
              <Input type="number" style={{width:"150px"}} value={formData.weekend_price} onChange={(e) => setFormData({ ...formData, weekend_price: e.target.value })} />
            </Col>
            <Col className='d-flex justify-content-center align-items-center mt-5'>
                <Button className='btn btn-primary' color='#fff' type='button' onClick={() => handleSubmit()}>Submit</Button>
            </Col>
          </Row>
        </CardHeader>
      </Card>
    </div>
  )
}

export default RRPPriceDetails
